// @ts-check
/**
 * D2C bill-of-materials — cost lines attached to a single product variant
 * (one size+color). Mounted under /api/admin/products.
 */
import api from '../utils/apiClient';

const adminProductMaterialService = {
  async getVariantMaterials(productId, variantId) {
    return api.get(`/api/admin/products/${productId}/variants/${variantId}/materials`);
  },

  /** @returns {Promise<{total_cost_per_unit_inr: number, lines: Object[]}>} */
  async getVariantMaterialsSummary(productId, variantId) {
    return api.get(`/api/admin/products/${productId}/variants/${variantId}/materials/summary`);
  },

  async addVariantMaterial(productId, variantId, data) {
    return api.post(`/api/admin/products/${productId}/variants/${variantId}/materials`, data);
  },

  async updateVariantMaterial(productId, variantId, lineId, data) {
    return api.put(`/api/admin/products/${productId}/variants/${variantId}/materials/${lineId}`, data);
  },

  async deleteVariantMaterial(productId, variantId, lineId) {
    return api.del(`/api/admin/products/${productId}/variants/${variantId}/materials/${lineId}`);
  },

  /** Clone every material line from another variant of the same product. */
  async copyFromVariant(productId, variantId, sourceVariantId) {
    return api.post(`/api/admin/products/${productId}/variants/${variantId}/materials/copy-from/${sourceVariantId}`);
  },
};

export default adminProductMaterialService;
